/*
  Subscription frequency buttons (Recharge widget)
  The widget lives in nested open shadow roots, so theme CSS can't reach the buttons. This adds a stylesheet to each
  <rc-selling-plans> shadow root so the first plan (30 days) is a full-width block and the rest sit in a row of three.
  Re-applies when the widget re-renders (variant change, section reload).
*/
(() => {
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(`
    .rc-plans-button-group label:first-of-type { width: 100%; }
    .rc-plans-button-group label:not(:first-of-type) { width: calc((100% - 24px) / 3); }
  `);

  function patchPlans(root, tries = 0) {
    root.querySelectorAll('rc-selling-plans').forEach((plans) => {
      const planRoot = plans.shadowRoot;
      if (!planRoot) {
        if (tries < 25) setTimeout(() => patchPlans(root, tries + 1), 200);
        return;
      }
      if (!planRoot.adoptedStyleSheets.includes(sheet)) {
        planRoot.adoptedStyleSheets = [...planRoot.adoptedStyleSheets, sheet];
      }
    });
  }

  function attach(widget) {
    const root = widget.shadowRoot;
    if (!root || widget.dataset.myomPlans) return;
    widget.dataset.myomPlans = '1';
    new MutationObserver(() => patchPlans(root)).observe(root, { childList: true, subtree: true });
    patchPlans(root);
  }

  let queued = false;
  function scan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll('recharge-subscription-widget').forEach(attach);
    });
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  scan();
})();
